<template src="../../templates/form/animal-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { maxLength, maxValue, minLength, required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { format } from 'date-fns'
import _filter from 'lodash/filter'

export default {
    name: 'AnimalForm',
    components: {
        Modal,
        Multiselect
    },
    props: ['animalToUpdate'],
    data() {
        return {
            animal: {}
        }
    },
    computed: {
        ...mapGetters([
            'filteredFarmAnimalsByType',
            'selectedFarm',
            'animals',
            'isBuckleNumberAlreadyGiven'
        ]),
        _birthday: {
            get() {
                return format(new Date(this.animal.birthday * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.animal.birthday = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _mother: {
            get() {
                return _filter(this.animals, { id: this.animal.mother })
            },
            set(newVal) {
                this.animal.mother = newVal.id
            }
        },
        _father: {
            get() {
                return _filter(this.animals, { id: this.animal.father })
            },
            set(newVal) {
                this.animal.father = newVal.id
            }
        },
        isFormValid() {
            return this.animal.id != null
                ? !this.$v.animal.birthday.$invalid &&
                    (this.animal.buckleNumber !== this.animalToUpdate.buckleNumber ||
                      this.animal.prevalenceSickness !== this.animalToUpdate.prevalenceSickness)
                : !this.$v.animal.birthday.$invalid && !this.$v.animal.buckleNumber.$invalid
        }
    },
    created() {
        this.animal = {
            id: this.animalToUpdate.id,
            birthday: this.animalToUpdate.birthday,
            buckleNumber: this.animalToUpdate.buckleNumber,
            type: this.animalToUpdate.type,
            isBought: this.animalToUpdate.isBought,
            father: this.animalToUpdate.father,
            mother: this.animalToUpdate.mother,
            prevalenceSickness: this.animalToUpdate.prevalenceSickness,
            building: this.selectedFarm.buildings[0].id
        }
    },
    validations: {
        animal: {
            birthday: {
                maxValue: maxValue(Math.trunc(Date.now() / 1000) + 24 * 60 * 60)
            },
            buckleNumber: {
                required,
                isUnique(value) {
                    if (value === '') {
                        return true
                    }
                    return !this.isBuckleNumberAlreadyGiven(value)
                },
                minLength: minLength(1),
                maxLength: maxLength(15)
            }
        }
    },
    methods: {
        ...mapActions(['createAnimal', 'editAnimal']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            if (this.isFormValid) {
                if (this.animal.id !== null) {
                    this.editAnimal(this.animal)
                } else {
                    this.createAnimal(this.animal)
                }
                this.close()
            }
        }
    }
}
</script>

<style lang="sass">
@import '../../sass/mixin/color'
@import '../../sass/mixin/flex'

#animal-modal
    .modal-container
        .modal-header
            background-color: $dd-light-orange
            color: white
        .modal-body
            form
                input, input:focus, input:valid, .multiselect
                    border-left: 8px solid $dd-light-orange
                .select
                    @include flex-center
                    .form-select
                        width: 100%
                        height: 40px
                        background: url('/img/br_down.png') 96% no-repeat #fff
                        border-left: 8px solid $dd-light-orange
                        border-bottom: none
                        border-right: none
                        border-top: transparent
                        padding: 0.25em
                        font-size: 16px
                        font-weight: bold
                        -webkit-appearance: none
                        -moz-appearance: none
                        appearance: none
                .rating-material
                    @include flexbox
                    @include flex-direction(row)
                    @include justify-content(space-around)
                    label
                        color: $grey2
                        font-size: 1em
                        font-weight: 700
                        width: 35px
                        height: 35px
                        border-radius: 50%
                        border-style: solid
                        border-color: $dd-light-orange
                        border-width: 1px
                        display: grid
                        place-items: center
                        background: white
                        transition: 0.2s ease-in-out
                        cursor: pointer
                        &:hover
                            background: $dd-light-orange
                            color: white
                    input
                        position: absolute
                        width: 35px
                        height: 35px
                        border-radius: 50%
                        opacity: 0
                        background-color: $grey2
                        &:checked + label
                            background: $dd-light-orange
                            color: white
                        &:hover
                            background: $grey2
                            color: $grey5



</style>
